// i18nOwl-ignore [app-cohort.triggerIntegrations.visit-link.title]
import type {TriggerIntegration} from '@cohort/merchants/apps';
import CohortVisitLinkTriggerIntegrationConfigComponent from '@cohort/merchants/apps/cohort/triggerIntegrations/visitLink/ConfigComponent';
import CohortVisitLinkTriggerIntegrationStepCompletionComponent from '@cohort/merchants/apps/cohort/triggerIntegrations/visitLink/StepCompletionComponent';
import type {CohortVisitLinkTriggerStruct} from '@cohort/shared/schema/apps/cohort/triggers/visitLink';
import {CohortVisitLinkTriggerIntegrationSpec} from '@cohort/shared/schema/apps/cohort/triggers/visitLink';

export const CohortVisitLinkTriggerIntegration: TriggerIntegration<CohortVisitLinkTriggerStruct> = {
  spec: CohortVisitLinkTriggerIntegrationSpec,
  configComponent: CohortVisitLinkTriggerIntegrationConfigComponent,
  stepCompletionComponent: CohortVisitLinkTriggerIntegrationStepCompletionComponent,
};
